import React, { useState} from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import BusinessGetAndDeleteImages from "./BusinessGetAndDeleteImages";

const ImageUpload = ({businessFromAdmin}) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const { business, businessToken, businessAdminToken } = useAuth(); 
  const [done, setDone] = useState(false)

  const currentBusiness = businessFromAdmin || business
  const currentBusinessToken = businessAdminToken || businessToken


  // Funkce pro výběr souborů a automatický upload
  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setSelectedImages(files);
    setMessage("");
    await handleUpload(files);
  };


  // Funkce pro upload souborů
  const handleUpload = async (files) => {
    if (!files || files.length === 0) return;

    setUploading(true);
    setMessage("");

    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));
    formData.append("businessId", currentBusiness?._id);
    console.log(currentBusinessToken)
    if (currentBusinessToken) {
          try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/images/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${currentBusinessToken}`,
          }
        }
      );
      console.log(selectedImages)
      setUploading(false);
      setMessage(response.data.message || "Obrázky úspěšně nahrány!");
      setSelectedImages([]);
    } catch (error) {
      setUploading(false);
      setMessage(error.response?.data?.message || "Chyba při nahrávání obrázků.");
      console.error("Chyba při nahrávání:", error);
    } finally {
      setTimeout(() => {
        setMessage(null)
        setDone(true)
      }, 2000)
    }
    }

  };


  return (
    <div >

      <p>Ideální formát 16:9</p>
      {/* Skrytý input pro výběr souborů */}
      <input
        type="file"
        id="fileInput"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        className="hidden-input"
      />

      {/* Tlačítko pro výběr souborů */}
      <button 
        className="profile-button"
        onClick={() => document.getElementById("fileInput").click()}
        disabled={uploading}
      >
        {uploading ? "Nahrávání..." : "Vybrat obrázky"}
      </button>
                <div>
                  <BusinessGetAndDeleteImages currentBusiness={currentBusiness} done={done} setDone={setDone} uploadMessage={message} />
                </div>

    </div>
  );
};

export default ImageUpload;